import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

@Injectable()
export class ContentService {
  public url: string = process.env.MIX_API;

  constructor(
    @Inject('$q') private $q: ng.IQService,
    @Inject('$http') private $http: ng.IHttpService,
  ) {}

  getCountryMeta(countryCode) {
    return this.$http.get(`${this.url}/meta/country/${countryCode}`)
      .then(response => response.data);
  }

  sendComments(data) {
    return this.$http.post(`${this.url}/email/expeditedtravel/contact`, data)
      .then(response => response.data);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/content.service.ts